import { Button } from "antd";
import React, { memo } from "react";
import styled from "styled-components";
import classnames from "classnames";
import { CloseBtnStyle } from "./CloseBtnStyle";

function CenterHeader({
  title,
  titleClass,
  backable,
  closable,
  backIconClass,
  closeIconClass,
  backClassName,
  closeClassName,
  disabledBack,
  disabledclose,
  onBack,
  onClose,
  ...props
}) {
  const renderBackIcon = () => (
    <Button
      className={classnames("position-absolute", backClassName)}
      onClick={onBack}
      style={{ background: "none", padding: "5px 0px" }}
      type="text"
      disabled={disabledBack}
    >
      <i style={{ fontSize: 28 }} className={classnames("feather-icon icon-chevron-left", backIconClass)}></i>
    </Button>
  );

  const renderCloseIcon = () => (
    <CloseBtnStyle $paddingHorizon={paddingHorizon} className={classnames(closeClassName, { "btn button-ktb-close": !backClassName })} onClick={onClose}>
      <i className={classnames("feather-icon icon-x", closeIconClass)}></i>
    </CloseBtnStyle>
  );

  return (
    <HeaderStyle {...props}>
      {backable && renderBackIcon()}
      <TitleStyle className={classnames("m-0", titleClass)}>{title}</TitleStyle>
      {closable && renderCloseIcon()}
    </HeaderStyle>
  );
}

CenterHeader.defaultProps = {
  backable: false,
  closable: false,
};

export default memo(CenterHeader);

const paddingHorizon = 20;

const HeaderStyle = styled.div`
  position: relative;
  /* border-bottom: 1px solid #EFEFEF; */
  padding: 12px ${paddingHorizon}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // width: 100vw;
  height: 60px;

  h5 {
    color: var(--ktb-navy-blue-main);
    font-size: 1.25rem;
  }
`;

const TitleStyle = styled.h5`
  width: 100%;
  text-align: center;
`;
